<template><BusinessPage module-key="leaves" /></template>
<script>import BusinessPage from '../common/BusinessPage.vue'; export default { name: 'LeavesPage', components: { BusinessPage } }</script>
